export function updateUrl(key: string, value: string): void {
	const currentUrlParams = new URLSearchParams(window.location.search)
	if (key === 'groupIds' && value === 'all') {
		currentUrlParams.delete(key)
	} else {
		currentUrlParams.set(key, value)
	}
	window.history.pushState({}, "", window.location.pathname + "?" + currentUrlParams.toString())
}